import styles from '../Pdf.module.css'
import {SmePddDoc} from '@peachy/assets'

// TODO src still has actual file path if element inspected
const Disclosure = () => {
    return <iframe class={styles.pdf} src={SmePddDoc} />
}

export default Disclosure
